import React from "react";
import "./Gallery.css";

import img1 from "../asset/35187.jpg";
import img2 from "../asset/IN_Premium-Tote-Bags_Hero-image_01.jpg";
import img3 from "../asset/71mgmQmgPjL._AC_UY350_.jpg";

const Gallery: React.FC = () => {
  return (
    <section className="gallery">

      <p className="small-title">— Our Work</p>

      <h2>
        Premium Jute, Canvas <br />
        & Nylon Bags
      </h2>

      <p className="gallery-subtext">
        Designed with care and manufactured with precision for durability,
        sustainability, and business growth.
      </p>

      <div className="gallery-buttons">
        <button className="btn-green">Contact Us</button>
        <button className="btn-light">View Our Work</button>
      </div>

      <div className="gallery-grid">

        <img src={img1} alt="Bag 1" />
        <img src={img2} alt="Bag 2" />
        <img src={img3} alt="Bag 3" />
        <img src={img1} alt="Bag 4" />
        <img src={img2} alt="Bag 5" />
        <img src={img3} alt="Bag 6" />

      </div>

    </section>
  );
};

export default Gallery;